import {ReactSketchCanvas} from "react-sketch-canvas";
import {useEffect, useRef, useState} from "react";
import DarkPen from '../../images/icons/dark-pen.svg'
import YellowPen from '../../images/icons/yellow-pen.svg'
import DarkEraser from '../../images/icons/dark-eraser.svg'
import YellowEraser from '../../images/icons/yellow-eraser.svg'
import Image from 'image-js';
import {CompactPicker} from "@hello-pangea/color-picker";
import ToggleInput from "./ToggleInput";

export default function DrawingInput(props) {
    const [isSaving, setIsSaving] = useState(false);
    const [referenceImage, setReferenceImage] = useState(null);
    const [invertMask, setInvertMask] = useState(false);
    const [strokeWidth, setStrokeWidth] = useState(5);
    const [brushColor, setBrushColor] = useState('#000000');
    const [brushMode, setBrushMode] = useState('brush');
    const [isMask, setIsMask] = useState(false);
    const [width, setWidth] = useState("512px");
    const [height, setHeight] = useState("512px");
    const [zoom, setZoom] = useState(0);
    const canvas = useRef(null);

    useEffect(() => {
        if (!referenceImage && isSaving) {
            canvas.current.exportImage('jpeg')
                .then(async data => {
                    let image = await Image.load(data);
                    if (isMask) {
                        image = image.grey().mask();
                        if (!invertMask) {
                            image = image.invert();
                        }
                    }
                    props.setImage(image.toBase64());

                }).finally(() => {
                    props.closeEvent();
                });
        }
    }, [canvas, referenceImage, isSaving])

    useEffect(() => {
        new Image.load(props.image).then(image => {
           setWidth(`${image.width}px`);
           setHeight(`${image.height}px`);
           setReferenceImage(props.image);
        });
    }, [props.image])

    useEffect(() => {
        setIsMask(props.isMask);
        if (props.isMask) {
            setStrokeWidth(50);
            setBrushColor('rgba(225,0,0,0.8)');
        }
    }, [props.isMask]);

    useEffect(() => {

    }, [zoom]);

    const saveImage = () => {
        if (props.isMask) {
            setReferenceImage(null);
            setIsSaving(true);
        } else {
            canvas.current.exportImage('jpeg')
                .then(async data => {
                    let image = await Image.load(data);
                    props.setImage(image.toBase64());
                    props.closeEvent();
                });
        }
    }

    console.log('Drawing input size', width, height);

    return (
        <div className={"mx-auto w-full max-w-screen-lg bg-white/50 overflow-auto"}>
            <ReactSketchCanvas
                ref={canvas}
                className={"border mx-auto bg-white"}
                width={width}
                height={height}
                strokeWidth={strokeWidth}
                eraserWidth={strokeWidth}
                strokeColor={brushColor}
                backgroundImage={referenceImage ? referenceImage : ""}
                canvasColor={'white'}
                exportWithBackgroundImage={true}
                preserveBackgroundImageAspectRatio={"xMidYMid meet"}
            />
            <div className={"flex flex-row gap-2 w-full flex-wrap justify-between p-2 items-center bg-white/50 rounded-bl-lg rounded-br-lg text-dark-blue"}>
                {/*<div className={""}>*/}
                {/*    <button className={`text-dark-blue text-2xl p-2 rounded`}><CgZoomIn /></button>*/}
                {/*    <button className={`text-dark-blue text-2xl p-2 rounded`}><CgZoomOut /></button>*/}
                {/*</div>*/}
                <div className={"flex flex-row gap-2"}>
                    <button className={`text-2xl p-2 rounded ${brushMode === "brush" ? "bg-dark-blue" : ""}`} onClick={() => {
                        setBrushMode("brush");
                        canvas.current.eraseMode(false);
                    }}>
                        {brushMode === "brush" ?
                            <img src={YellowPen} className='h-7'/>
                        :
                            <img src={DarkPen} className='h-7'/>    
                        }
                    </button>
                    <button className={`text-2xl p-2 rounded ${brushMode === "erase" ? "bg-dark-blue" : ""}`} onClick={() => {
                        setBrushMode("erase");
                        canvas.current.eraseMode(true);
                    }}>
                        {brushMode === "erase" ?
                            <img src={YellowEraser} className='h-7'/>
                        :
                            <img src={DarkEraser} className='h-7'/>    
                        }
                    </button>
                </div>
                <div className={""}>
                    <label htmlFor="BrushSize"
                           className="w-full flex flex-row gap-4 items-center mb-2 text-sm font-medium">
                        <span>Brush Size</span>
                        <span className={"block flex-grow bg-white px-2 py-1 rounded text-dark-blue text-right"}>{strokeWidth}</span>
                    </label>
                    <input id="BrushSize" type="range" value={strokeWidth} step={5} min={5} max={100} onChange={(e) => setStrokeWidth(Number(e.target.value))}
                           className="w-full h-2 mb-6 bg-gray-200 rounded-lg appearance-none accent-yellow cursor-pointer" />
                </div>
                {!isMask ?
                    <CompactPicker onChange={(color) => setBrushColor(color.hex)} />
                    : <div>
                        <label htmlFor={"invertMask"}>
                            <ToggleInput id={""} checked={invertMask} onChange={() => setInvertMask(!invertMask)} /> Invert Mask
                        </label>
                    </div> }
                <button className={"w-full flex-grow p-2 bg-yellow text-dark-blue rounded font-bold"} onClick={saveImage}>Use {!isMask ? 'Image' : 'Mask'}</button>
            </div>
        </div>
    );
}
